import React, { useEffect, useState } from 'react';
import { API } from '../../Services/api';
import MusicContainer from './MusicContainer';
import Preloader from '../../Components/Preloader';
import AdminCommentContainer from './AdminCommentContainer';

function Admin() {
    const [isPossiblyPhone, setPossiblyPhone] = useState(window.innerWidth < window.innerHeight);
    const [music, setMusic] = useState([]);
    const [musicLoading, setMusicLoading] = useState(true);
    const [musicFile, setMusicFile] = useState(null);
    const [coverFile, setCoverFile] = useState(null);
    const [musicPreloader, setMusicPreloader] = useState(false);

    const [comments, setComments] = useState([]);
    const [commentsLoading, setCommentsLoading] = useState(true);

    const [tokenValue, setTokenValue] = useState("");

    const [musicFormData, setMusicFormData] = useState({
        title: '',
        author: '',
    });

    const [error, setError] = useState("");

    const handleMusicFile = (event) => {
        const selectedFile = event.target.files[0];

        if (selectedFile) {
            var name = selectedFile.name
            if (name.length > 14) {
                const fileType = name.split(".")[1]
                name = name.substring(0, 14) + "... ." + fileType;
            }
            setMusicFile(selectedFile);
            document.getElementById("music-file-name").textContent = name;
            document.getElementById("audio-src").setAttribute("src", URL.createObjectURL(selectedFile));
            document.getElementById("music-track").className = "music-track-audio";
            document.getElementById("music-track").load();
        }
    };

    const handleCoverFile = (event) => {
        const selectedFile = event.target.files[0];

        if (selectedFile) {
            var name = selectedFile.name
            if (name.length > 14) {
                const fileType = name.split(".")[1]
                name = name.substring(0, 14) + "... ." + fileType;
            }
            setCoverFile(selectedFile);
            document.getElementById("cover-file-name").textContent = name;
            document.getElementById("cover-img").setAttribute("src", URL.createObjectURL(selectedFile));
            document.getElementById("cover-img").className = "cover-image";
        }
    };

    const handleTokenChange = async (e) => {
        e.preventDefault();
        localStorage.setItem("token", tokenValue);
        setTokenValue("");
    };

    const handleMusicSubmit = async (e) => {
        e.preventDefault();
        
        const data = new FormData();
        data.append("title", musicFormData.title);
        data.append("author", musicFormData.author);
        data.append("cover", coverFile);
        data.append("audio", musicFile);

        try {
            setError("");
            setMusicPreloader(true);
            await API.addMusic(data);
            window.location.reload();
        } catch (error) {
            setError(`${error.status}, ${error}`);
            console.error("Error in adding new music: ", error);
        } finally {
            setMusicPreloader(false);
        };
    };

    useEffect(() => {
        const handleResize = () => {
            setPossiblyPhone(window.innerWidth < window.innerHeight);
        };

        const fetchMusic = async () => {
            try {
                const response = await API.getAllMusic();
                setMusic(response.data);
            } catch (error) {
                console.error("Error fetching music:", error);
            } finally {
                setMusicLoading(false);
            }
        };
        fetchMusic();

        const fetchComments = async () => {
                try {
                    const response = await API.getAllComments();
                    setComments(response.data);
                } catch (error) {
                    console.error("Error fetching comments:", error);
                } finally {
                    setCommentsLoading(false);
                }
            };
            fetchComments();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, []);

    return (
        <div className="block">
            <div className='name-block'>
                <h1 className='name'>admin page</h1>
            </div>
            <div className="admin-block">
                <div className='admin-box'>
                    <p className="title-box">Change token</p>
                    <label className="text-file">
                        <p className="text-input-title">Token</p>
	   	                <input onChange={(e) => setTokenValue(e.target.value)} id="token-input" className="text-file-text long" id="name-text" type="text" />        
                    </label>
                    <div className="button-upload-block">
                        <button
                            onClick={handleTokenChange}
                            className="button-upload-music mini">Set
                        </button>
                    </div>
                </div>
                <div className='admin-box'>
                    <p className="title-box">Configure music</p>
                    <form className="admin-box-in-box" onSubmit={handleMusicSubmit}>
                        <p className="mini-title-box">Upload new one</p>
                        <label className="input-file">
	   	                    <span id="music-file-name" className="input-file-text"></span>
	   	                    <input required onChange={handleMusicFile} id="music-file" accept="audio/*" type="file" />        
 	   	                    <span className="input-file-btn">Select music file</span>
 	                    </label>
                        <audio className="music-track-audio disabled" id="music-track" controls >
                            <source src="" id="audio-src" />
                        </audio>
                        <label className="text-file">
                            <p className="text-input-title">Name</p>
	   	                    <input onChange={(e) => setMusicFormData({...musicFormData, title: e.target.value})} required className="text-file-text" id="name-text" type="text" />        
 	                    </label>
                        <label className="text-file">
                            <p className="text-input-title">Author</p>
	   	                    <input onChange={(e) => setMusicFormData({...musicFormData, author: e.target.value})} required className="text-file-text" id="author-text" type="text" />        
 	                    </label>
                        <label className="input-file">
	   	                    <span id="cover-file-name" className="input-file-text"></span>
	   	                    <input required onChange={handleCoverFile} id="cover-file" accept="image/*" type="file" />        
 	   	                    <span className="input-file-btn">Select cover album</span>
 	                    </label>
                        <div className="cover-img-block">
                            <img alt="cover" id="cover-img" className="cover-image disabled" />
                        </div>
                        <div className="button-upload-block">
                            {!musicPreloader ? (
                                <button className="button-upload-music">Upload</button>
                            ) : (
                                <button disabled className="button-upload-music disabled"><div className="custom-loader-spinner" /></button>
                            )}
                        </div>
                        {error !== "" && (
                            <p className="music-error">{error}</p>
                        )}
                    </form>
                    <div className="admin-box-in-box">
                        <p className="mini-title-box">Current tracklist</p>
                        <div className="list-in-box">
                            {musicLoading ? (
                                <div>
                                    <Preloader customMargin={20} />
                                </div>
                            ) : (
                                music.length < 1 ? (
                                    <div className="dont-found-block">
                                        <p className="dont-found-text">Nothing to show</p>
                                    </div>
                                ) : (
                                    music.map(item => (
                                        <MusicContainer key={item.id} data={item} />
                                    ))
                                )
                            )}
                        </div>
                    </div>
                </div>
                {!commentsLoading && (
                    <div className='admin-box'>
                        <p className="title-box">Current comments</p>
                        <div className='admin comment-box'>
                            {comments.length < 1 ? (
                                <div className="dont-found-block">
                                    <p className="dont-found-text">Nothing to show</p>
                                </div>
                            ) : (
                                comments.map(item => ( 
                                    <AdminCommentContainer key={item.id} data={item} />
                                ))
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Admin;
